import { render, staticRenderFns } from "./quotations-too-long-status.vue?vue&type=template&id=5bf8e957"
import script from "./quotations-too-long-status.vue?vue&type=script&lang=js"
export * from "./quotations-too-long-status.vue?vue&type=script&lang=js"
import style0 from "./quotations-too-long-status.vue?vue&type=style&index=0&id=5bf8e957&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports